import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function Cancellations({ children }) {
  useInjectSaga({ key: 'reportsCancellations', saga });
  useInjectReducer({ key: 'reportsCancellations', reducer });

  return React.Children.only(children);
}

Cancellations.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withReportsCancellations } from './withReportsCancellations';
export default compose(withConnect, memo)(Cancellations);
